import React from 'react';
import Header from '../components/Header';

const ComingSoon = () => {
  return (
    <div className="min-h-screen overflow-hidden relative" style={{ backgroundColor: 'rgb(249, 248, 241)' }}>
      <Header />
      
      {/* 主要内容 */}
      <div className="min-h-screen flex flex-col items-center justify-center px-6" style={{ paddingTop: '80px' }}>
        {/* 简洁的文字内容 */}
        <div className="text-center max-w-4xl mx-auto">
          <h1 
            className="font-bold text-gray-800 leading-tight"
            style={{ 
              fontFamily: 'Palatino, "Palatino Linotype", "Book Antiqua", serif',
              fontStyle: 'italic',
              letterSpacing: '0.5px',
              lineHeight: '1.1',
              fontSize: 'clamp(1.25rem, 3.5vw, 4rem)'
            }}
          >
            Thanks for your attention,<br/>
            something amazing is<br/>
            coming soon!
          </h1>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
